export function countDayDate(start, end) {
  const date1 = new Date(start);
  const date2 = new Date(end);
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.floor((date2.getTime() - date1.getTime()) / oneDay) + 1;
}

export function isDostup(time, date, now) {
  const timeTeacher = new Date(now);
  const strTime = time.split(':');
  timeTeacher.setHours(strTime[0]);
  timeTeacher.setMinutes(strTime[1]);
  timeTeacher.setSeconds(strTime[2]);

  const countDay = countDayDate(now, date);
  if (countDay < 0) return false;
  if (countDay === 0) return !(timeTeacher < now);
  return true;
}

export function checkPp(isChecked, item, dostup) {
  if (isChecked) return false;
  return !dostup || Number(item.balance) < 60;
}

export function checkGpd(isChecked, item, dostup) {
  if (isChecked) return false;
  if (!dostup) return true;
  const balance = Number(item.balance || 0);
  const city = item.city.toLowerCase();
  return (
    (balance < 40 && city === 'балаково') ||
    (balance < 60 && city === 'энгельс')
  );
}

export function checkGpdP(isChecked, item, dostup) {
  if (isChecked) return false;
  return !dostup || item.LGOTA == 0;
}

export function checkGpdPD(isChecked, item, dostup) {
  if (isChecked) return false;
  if (!dostup || item.LGOTA != 1) return true;
  const balance = Number(item.balance || 0);
  const city = item.city.toLowerCase();
  return (
    (balance < 40 && city === 'балаково') ||
    (balance < 60 && city === 'энгельс')
  );
}

export function checkLg(isChecked, item, summ, dostup) {
  if (isChecked) return false;
  if (summ) {
    return !dostup || item.LGOTA !== '1' || Number(item.balance) < 17;
  }
  return false;
}

export function updateLgFood(row, column) {
  if (!row || !column) return;
  let check = row[column];

  if (check) {
    if (
      (row.type_lgota && row.type_lgota == 'моб') ||
      row.type_lgota == 'овз'
    ) {
      switch (column) {
        case 'gpdP':
          row.gpd = false;
          row.gpdPD = false;
          break;

        case 'gpdPD':
          row.gpd = false;
          row.gpdP = false;
          break;

        case 'gpd':
          row.gpdP = false;
          row.gpdPD = false;
          break;
      }
      let arr = [
        row.lgZ1,
        row.lgO1,
        row.lgP1,
        row.lgZ,
        row.lgO,
        row.gpdP,
        row.gpdPD,
      ];
      if (arr.filter(x => x).length > 2) {
        setTimeout(() => {
          row[column] = false;
        }, 200);
      }
    } else {
      switch (column) {
        case 'lg':
          row.lgZ = false;
          row.lgO = false;
          row.lgZ1 = false;
          row.lgO1 = false;
          row.gpdP = false;
          row.gpdPD = false;
          break;
        case 'lgZ':
          row.lg = false;
          row.lgO = false;
          row.lgZ1 = false;
          row.lgO1 = false;
          row.gpdP = false;
          row.gpdPD = false;
          break;
        case 'lgO':
          row.lgZ = false;
          row.lg = false;
          row.lgZ1 = false;
          row.lgO1 = false;
          row.gpdP = false;
          row.gpdPD = false;
          break;
        case 'lgZ1':
          row.lgZ = false;
          row.lg = false;
          row.lgO = false;
          row.lgO1 = false;
          row.gpdP = false;
          row.gpdPD = false;
          break;
        case 'lgO1':
          row.lgZ = false;
          row.lg = false;
          row.lgZ1 = false;
          row.lgO = false;
          row.gpdP = false;
          row.gpdPD = false;
          break;
        case 'lgP1':
          row.lgZ = false;
          row.lg = false;
          row.lgZ1 = false;
          row.lgO = false;
          row.gpdP = false;
          row.gpdPD = false;
          break;

        case 'gpdP':
          row.lgZ = false;
          row.lg = false;
          row.lgZ1 = false;
          row.lgO = false;
          row.lgO1 = false;
          row.gpd = false;
          row.gpdPD = false;
          break;

        case 'gpdPD':
          row.lgZ = false;
          row.lg = false;
          row.lgZ1 = false;
          row.lgO = false;
          row.lgO1 = false;
          row.gpd = false;
          row.gpdP = false;
          break;

        case 'gpd':
          row.gpdP = false;
          row.gpdPD = false;
          break;
      }
      let arr = [row.lgZ1, row.lgO1, row.lgP1];
      if (arr.filter(x => x).length > 1) {
        setTimeout(() => {
          row[column] = false;
        }, 200);
      }
    }
  }
}

export function updateBpFood(row, column, selo) {
  if (!row || !column) return;
  let check = row[column];

  if (selo) {
    return;
  }

  if (check) {
    switch (column) {
      case 'bp':
        row.bpO = false;
        break;
      case 'bpO':
        row.bp = false;
        break;
    }
  }
}
